module.exports = "img/upload-big.4e229de.svg";